// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "img[data-v-af1b282a] {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  /* This stops dragging in chrome */\n  -webkit-user-drag: none;\n  opacity: 0;\n  max-width: 100%;\n  max-height: 100%;\n}\nimg.img-loaded[data-v-af1b282a] {\n  opacity: 1;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
